<template>
    <ul
        v-if="recentShows && 0 !== recentShows.length"
        class="sidebar-shows"
    >
        <li class="sidebar-label">
            <span>Your shows:</span>
        </li>
        <transition-group
            name="fade"
            mode="out-in"
        >
            <li
                v-for="show in recentShows"
                :key="show.id"
                class="recent-show"
            >
                <router-link
                    v-slot="{ href, navigate, isActive }"
                    :to="`/shows/${show.hash}`"
                >
                    <a
                        :class="[isActive && 'router-link-active']"
                        :href="href"
                        @click="navigate"
                    >
                        <base-show-image
                            :show="show"
                            size="small"
                            :has-border="isActive"
                            border-color="gray"
                        />
                    </a>
                </router-link>
            </li>
        </transition-group>
    </ul>
</template>

<script>
import { mapState } from 'vuex';
import { sortBy } from 'lodash';

export default {
    computed: {
        ...mapState(['shows']),

        /**
         *
         * @returns  {Array}  Returns first 3 shows
         */
        recentShows() {
            return sortBy(this.shows, 'created_at').slice(0, 3) || false;
        },
    },
};
</script>
